import { Button, RadioGroup, RadioGroupItem } from '@scholastic/mockingjay';
import { useState, type FormEvent } from 'react';
import { useGetMeApi } from 'eds-common/api/v2';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';

export function ConfirmOrganization() {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const { goToNextStep, updateRedemptionData } =
    useAccessCodeRedemptionContext();
  const { data: user } = useGetMeApi();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (selectedValue === null) {
      return;
    }

    const isConfirmed = selectedValue === 'yes';
    updateRedemptionData({ confirmedOrganization: isConfirmed });
    goToNextStep();
  };

  const handleValueChange = (value: string) => {
    setSelectedValue(value);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-14">
      <div className="flex flex-col gap-6 text-lg text-neutral-900">
        <p>
          Our records show you are part of{' '}
          <strong className="font-bold">{user?.currentOrg.orgName}</strong>.
        </p>

        <RadioGroup
          value={selectedValue || ''}
          onValueChange={handleValueChange}
          aria-label="Confirm your organization"
        >
          <RadioGroupItem value="yes" label="Yes. This is my organization." />
          <RadioGroupItem
            value="no"
            label="No. I'm part of a different organization."
          />
        </RadioGroup>

        {selectedValue === 'no' && (
          <p className="text-base text-neutral-700">
            Change your organization at any time by updating it in your{' '}
            <a
              href="https://account.scholastic.com/my-scholastic/profile/my-profile.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-700 underline"
            >
              MyScholastic profile
              <span className="sr-only"> (opens in new tab)</span>
            </a>
            .
          </p>
        )}
      </div>

      <div className="flex justify-end">
        <Button
          type="submit"
          variant="primary"
          disabled={selectedValue === null}
        >
          Next
        </Button>
      </div>
    </form>
  );
}
